// React
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// UI
import { toast } from 'sonner';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Toaster } from '../components/ui/sonner';

// FutureLab
import { useCreateGroupChatMutation } from '../store/api/chatApi';
import { chatItemInFocus } from '../actions/chatItemInFocusActions';
import { UserProfileDetails } from './AddChatPage';
import InputField from '../components/common/InputField';
import { useLazyGetDirectoryUsersQuery } from '../store/api/userApi';

// Reducer
import { store } from '../ReduxRoot';

// 3rd Party
import _ from 'lodash';

interface CreateGroupChatForm {
	chatGroupName?: string;
	groupChatDescription?: string;
}

export function AddGroupChatPage() {
	const [userList, setUserList] = useState<UserProfileDetails[]>([]);
	const [selectedUserList, setSelectedUserList] = useState<UserProfileDetails[]>([]);
	const [filterQuery, setFilterQuery] = useState('');
	const [createGroupChat] = useCreateGroupChatMutation();
	const [loadDirectoryUsers] = useLazyGetDirectoryUsersQuery();
	const navigate = useNavigate();
	const photoUrl = `${process.env.REACT_APP_PROFILE_PHOTOS_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_BASE_URL}${process.env.REACT_APP_PROFILE_PHOTOS_S3_DIRECTORY_URL}`;

	const [formValues, setFormValues] = useState<CreateGroupChatForm>({
		chatGroupName: '',
		groupChatDescription: '',
	});

	const filterObject = {
		filter: {
			firstName: '',
			lastName: '',
			email: '',
		},
	};

	useEffect(() => {
		loadDirectoryUsers(filterObject)
			.unwrap()
			.then((users) => {
				setUserList(users);
			})
			.catch((err) => {
				console.warn('Error:', err);
			});
	}, [loadDirectoryUsers]);

	const getGeryResults = () => {
		return userList.filter((user) => user.email.includes(filterQuery));
	};

	const addUserToGroupUsersList = (userDetails: UserProfileDetails): void => {
		const selectedUserListClone = _.cloneDeep(selectedUserList);
		if (selectedUserListClone.find((selectedUser) => selectedUser.id === userDetails.id)) {
			const filteredList = selectedUserListClone.filter((selectedUser) => selectedUser.id !== userDetails.id);
			setSelectedUserList(filteredList);
		} else {
			selectedUserListClone.push(userDetails);
			setSelectedUserList(selectedUserListClone);
		}
	};

	const submitForm = () => {
		createGroupChat({
			groupChatName: formValues.chatGroupName,
			groupChatDescription: formValues.groupChatDescription,
			recipientUserIds: selectedUserList.map((ele) => ele.id),
		})
			.unwrap()
			.then((chat) => {
				store.dispatch(chatItemInFocus(chat));
				navigate('../chat/chat-room');
			})
			.catch(() => toast.error('Chat Already Exists'));
	};

	return (
		<div className="add-group-chat h-full min-w-0 overflow-x-hidden">
			<Toaster position="bottom-center" />
			<form
				className="min-w-0 space-y-3 p-3"
				onSubmit={(event) => {
					event.preventDefault();
					submitForm();
				}}
			>
				<InputField
					name="chatGroupName"
					placeholder="Chat Group Name"
					value={formValues.chatGroupName}
					onChange={(event) => setFormValues((current) => ({ ...current, chatGroupName: event.target.value }))}
				/>
				<InputField
					name="groupChatDescription"
					placeholder="Chat Group Description"
					value={formValues.groupChatDescription}
					onChange={(event) =>
						setFormValues((current) => ({ ...current, groupChatDescription: event.target.value }))
					}
				/>
				<Button type="submit" className="w-full">
					Create Group
				</Button>
			</form>
			<div className="search-chat-bar min-w-0">
				<Input
					aria-label="Search users"
					placeholder="Search"
					value={filterQuery}
					onChange={(event) => setFilterQuery(event.target.value)}
				/>
			</div>
			<div className="search-chat-bar min-w-0">
				<div className="flex min-w-0 flex-wrap gap-2">
					{selectedUserList.map((selectedUser) => (
						<Badge className="max-w-full truncate" key={selectedUser.id} variant="secondary">
							{selectedUser.email}
						</Badge>
					))}
				</div>
			</div>
			<div className="vertical-scroll-enabled-group-chat min-w-0 overflow-x-hidden">
				{getGeryResults().map((user) => {
					return (
						<button
							type="button"
							key={user.id}
							className="user-list-row flex w-full min-w-0 items-center text-left"
							aria-pressed={selectedUserList.some((selectedUser) => selectedUser.id === user.id)}
							onClick={() => addUserToGroupUsersList(user)}
						>
							<div className="w-16 shrink-0">
									<div className="chat-list-photo-holder">
										<img
											src={`${photoUrl}/${user.id}/${user.profile_photo}`}
											className="chat-list-image-holder"
											alt=""
										/>
									</div>
							</div>
							<div className="add-chatlist-one-to-one-title min-w-0 flex-1 pr-3">
									<div className="truncate">{user.email}</div>
							</div>
						</button>
					);
				})}
			</div>
		</div>
	);
}
